import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { EspelhoAPI } from "../../apis/EspelhoAPI";


const SetEspelhoLabelModal = ({ open, handleClose, selectedEspelho }) => {
    const [label, setLabel] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCloseModal = () => {
        setLabel('');
        handleClose();
    }

    const handleSubmit = () => {
        // console.log(selectedEspelho);
        // console.log(label);
        setLoading(true);
        const data = { label: label }
        EspelhoAPI.setEspelhoLabel(selectedEspelho.Id, data)
            .then((res) => {
                console.log(res);
                // setNewUser({
                //     userName: '',
                //     password: '',
                // });
                // setAlert({ ...alert, visible: false });
                // navigate('/admin/gestao/usuarios');
            })
            .catch((e) => {
                console.log(e);
                // setIsLoading(false);
                // setAlert({ visible: true, text: e?.response?.data?.Errors });
            })
            .finally(() => {
                setLoading(false);
                handleClose();
            });
    }
    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
        // PaperProps={{
        //     component: 'form',
        //     onSubmit: (event) => {
        //         event.preventDefault();
        //         const formData = new FormData(event.currentTarget);
        //         const formJson = Object.fromEntries(formData.entries());
        //         const email = formJson.email;
        //         console.log(email);
        //         handleClose();
        //     },
        // }}
        >
            <DialogTitle>Definir nome de espelho</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Digite o nome para o espelho de identificador <strong>{selectedEspelho?.Identifier}</strong>.
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="label"
                    name="label"
                    label="Nome"
                    fullWidth
                    variant="standard"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseModal} disabled={loading}>Cancelar</Button>
                <Button onClick={handleSubmit} disabled={loading}>Salvar</Button>
            </DialogActions>
        </Dialog>
    )
}
export default SetEspelhoLabelModal;